/* Ten Antennas — panel plumbing.

   Three jobs:

   1. Publish --ta-header-h. Dawn's own --header-height is 0 on this store: it
      is derived from the header SECTION's offsetHeight, and the section's
      custom CSS sets position:absolute, which collapses it. A CSS fallback
      cannot cover that — the variable exists, it is just zero.

   2. Relocate the currency and language controls out of the header bar and
      into the bottom of the panel. They are MOVED, not copied — Dawn's
      localization-form element carries its own listeners and form state, so a
      clone would look right and submit nothing.

   3. Lock page scroll while the panel is open, replacing the scrollbar with
      padding so the layout does not jump sideways. */
(function () {
  if (window.__taPanel) return;
  window.__taPanel = true;

  var root = document.documentElement;

  function publishHeight() {
    var el = document.querySelector('header.header');
    if (!el) return;
    var h = Math.round(el.getBoundingClientRect().height);
    if (h > 0) root.style.setProperty('--ta-header-h', h + 'px');
  }

  function relocateLocale() {
    var source = document.querySelector('.header__icons > .desktop-localization-wrapper');
    if (!source) return;
    var panel = document.querySelector('.mega-menu__content');
    if (!panel) return;
    if (!source.children.length) return;

    var host = panel.querySelector('.mega-menu__locale');
    if (!host) {
      host = document.createElement('div');
      host.className = 'mega-menu__locale';
      panel.appendChild(host);
    }
    if (host.contains(source)) return;
    host.appendChild(source);
  }

  function anyOpen() {
    return !!document.querySelector('details.mega-menu[open]');
  }

  function syncScrollLock() {
    if (anyOpen()) {
      if (root.style.overflow === 'hidden') return;
      var gap = window.innerWidth - root.clientWidth;
      root.style.overflow = 'hidden';
      if (gap > 0) root.style.paddingRight = gap + 'px';
    } else if (root.style.overflow === 'hidden') {
      root.style.overflow = '';
      root.style.paddingRight = '';
    }
  }

  function closeOpenMega() {
    document.querySelectorAll('details.mega-menu[open]').forEach(function (details) {
      var host = details.closest('header-menu');
      if (host && typeof host.close === 'function') {
        host.close();
      } else {
        details.removeAttribute('open');
      }
    });
    syncScrollLock();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mega-close]')) {
      event.preventDefault();
      closeOpenMega();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeOpenMega();
  });

  document.addEventListener('toggle', function (event) {
    if (event.target instanceof HTMLDetailsElement && event.target.classList.contains('mega-menu')) {
      publishHeight();
      syncScrollLock();
    }
  }, true);

  document.addEventListener('click', syncScrollLock, true);
  document.addEventListener('focusout', syncScrollLock, true);

  function boot() {
    publishHeight();
    relocateLocale();
  }

  window.addEventListener('resize', publishHeight);
  window.addEventListener('load', boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 600);
})();
